const TEST = 'test'; // eslint-disable-next-line import/no-mutable-exports -- needed

export let isSessionStorageSupported = () => {
  try {
    sessionStorage.setItem(TEST, TEST);
    sessionStorage.removeItem(TEST);

    isSessionStorageSupported = () => true;

    return isSessionStorageSupported();
  } catch (error) {
    isSessionStorageSupported = () => false;

    return isSessionStorageSupported();
  }
};
//# sourceMappingURL=isSessionStorageSupported.js.map